export default {
  index: [
    {
      path: '/dkfw',
      component: resolve => require(['./dkfwIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/dk_fw/_router.js